export const isSpecialized = function(material){    
    const specialized_materials = ["ریاضی", "علوم تجربی", "شیمی", "فیزیک", "استعداد تحلیلی", "استعداد تحلیلی 1", "استعداد تحلیلی 2", "زیست و زمین شناسی"]
    if(specialized_materials.includes(material)){
        return true;
    }
    return false;
}